export default __webpack_public_path__ + "static/media/NETT.167a6b94.png";